import { useModalDialog } from '../../../hooks'

export const useStoryDialog = () => {

  const { showModalDialog } = useModalDialog()

  const showDeleteStoryDialog = (data, onSubmit) => {

    const config = {
      title: "Ta bort story",
      Content: () => <div>Detta tar permanent bort <strong>{data.topic || data.slug}</strong>.</div>,
      onSubmit: () => onSubmit(data),
      submitLabelLoading: "Tar bort...",
    }

    showModalDialog(config)
  }

  return {
    showDeleteStoryDialog,
  }
}
